// ContactsPage.tsx · v1.10 · v12.10.25.2 (Tushar 10/30: Linked people stays - merge text says 'the linked people' again)
// ContactsPage.tsx · v1.9 · v12.10.25 (#2108 Merge into: a no-name contact reads 'No name yet (VS-…)' once, never 'VS-… (VS-…)') · 2026-10-30 · VoiceSpectrum AI
// ContactsPage.tsx · v1.8 · v12.10.22.2 (B6 Chinese merged) (#2027, UI-PROTO-CONTACT-PREFERRED-NAME-B6 v1.3 LOCKED: the name in the
//   contact's preferred language as text right under First name / Last name in Edit details - click to type, Enter or click away keeps,
//   Esc cancels; empty = "+ <language>"; every preferred language except English; nowhere else) · 2026-10-28 · VoiceSpectrum AI
// ContactsPage.tsx · v1.7 · v12.10.22 (#1970 a list field is a dropdown of its List; #1961 the search shows as a chip with x + Clear all; #1964 the Preferred language pill beside the caller-type pill, card and drawer; #1963 the +N tooltip draws above the sticky search bar) · 2026-10-28 · VoiceSpectrum AI
// ContactsPage.tsx · v1.6 · v12.10.21 (#1930 #1931 D1-D18 to UI-PROTO-CALLER-TYPE-CONTACTS v1.7: avatar = caller-type badge (icon + colour from
//   Personalization › Caller types), caller-type pill, no Contact / Patient / Caller pills, "Primary +1 (…) · Mobile · Last call … · #ref · N calls",
//   Source chip Import from DigiDMS / Merged from DigiDMS / Call, green tick + tooltip on confirmed fields / phones / caller rows, "caller gave
//   another detail", Phone 1-4 + Callback pill, Caller + Relation rows (#1941), a phone click copies digits only (D18), the link CHECK flag
//   (#1919 C3), office contacts one Full name (D8); #1946 the gear before Import opens Contact book settings) · 2026-10-26 · VoiceSpectrum AI
// ContactsPage.tsx · v1.5 · v12.10.17.1 (#1791 an imported contact reads "Import from DigiDMS" on the list card, not "Added on call") · 2026-10-16 · VoiceSpectrum AI
// ContactsPage.tsx · v1.4 · v12.10.17 (#1747 a call the ID check linked reads "confirmed at the ID check") · 2026-10-16
// ContactsPage.tsx · v1.3 · v12.10.17 (#1746 Import patients - the Import button opens ContactImport; Phone 1-3 with type and ★ Primary
//   in view and Edit, the type on the card, "Import from <source>" chip / Source row / History; #1777 Caller type + Preferred language
//   (view + dropdowns in Edit, no free typing) and "Verified: phone · N times · last <date>, call #<ref>") · 2026-10-16
// ContactsPage.tsx · v12.10.17 (#1773 the call reference reads #42-0700, as in Messages) · 2026-10-16
// ContactsPage.tsx · v12.10.11.1 (#1489 ⋮ Delete contact… - Contacts › Delete; linked to calls -> "Delete with its calls" or Merge; restorable 30 days) · 2026-10-09
// ContactsPage.tsx · v12.10.9.4 (#1379 403 = no access) · 2026-10-07 · VoiceSpectrum AI
// ContactsPage.tsx · v1.2 · v12.10.8 (#1221 ZIP code next to DOB, the address has its own Address ZIP; #1223 'Added on call' / 'Added by <user>';
//   #1227 a system field switched Off in Vocabulary is not shown) · 2026-10-05 · VoiceSpectrum AI
// ContactsPage.tsx · v1.1 · v12.10.7.1 (#1173-#1189 Contacts to the locked prototype v1.6 and the 10/5 rules; UI-LOCK-12.10.7.1 v1.3) · 2026-10-05 · VoiceSpectrum AI
// v1.0 · v12.10.7 (#1163 list + drawer, #1164 edit + add, #1165 manual merge, #1162 consent by hand) · 2026-10-04
//
// T14 Contacts Phase 1 (Documents\Brain\Contacts\CONTACTS-PHASES_v1.21.html). The locked prototype
// ContactBook_Layout v1.6 MINUS the later-phase parts: no Patients / Callers / Needs review tabs (every contact is
// Caller + Patient, no review states - S5 / S8), no Reach through (Phase 2, S45), Call is shown disabled (T18), the
// call-count pill is not clickable until Messages can filter by contact (Phase 3).
// v1.1 (12.10.7.1):
//   #1173 / #1189  Details in the prototype places from VOCABULARY (S31): First | Last, Phone | Email, DOB | System ID,
//                  Address (full width), External ID - then a CUSTOM section (S32). Validation and display by type (S33).
//   #1175 / #1176  External ID under the name with a copy button; on the card's second line; searchable.
//   #1177          Action row: Call (disabled) · Send text (the Messages compose window, no templates - logged in this
//                  contact's History only, S46) · ⋮ Merge into…  The top bar keeps ‹ System ID › and close only.
//   #1178          Linked people - paired relations, both sides, ⋮ Unlink.
//   #1179          Address as its parts, with Maps suggestions that fill them.
//   #1180 / #1181  Chips with icons and the prototype tooltips (hover, focus and tap); the consent box wording.
//   #1182          "New contact" said once.   #1184 one edit at a time.   #1185 the Messages '>' on every card.
//   #1183 / #1187  (contacts.css) header under the top bar; 16px inputs on touch, the right keyboard per field.
import { useEffect, useMemo, useRef, useState, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import api, { ApiError } from '../../lib/api';
import { toast } from '../../lib/toast';
import { maskPhone, phoneFromInput, phoneError } from '../../lib/phone';
import { formatReference } from '../../lib/reference';   // v12.10.17 (#1773): the same #42-0700 Messages shows
import TextComposer from '../../components/TextComposer';
import ImportDrawer, { PHONE_TYPES } from './ContactImport';   // v12.10.17 (#1746)
import ContactBookSettingsDrawer from './ContactBookSettings';   // v12.10.21 (#1946 D14)
import { CallerTypeIcon } from '../../components/CallerTypeIcon';   // v12.10.21 (#1930 D1): the Messages avatar glyphs
import './contacts.css';
import { useAccess } from '../../lib/useAccess';   // v12.10.9.4 (#1379)

type FieldDef = { token: string; label: string; type: string; identity: boolean; section?: string; place?: string | null; options?: string[] | null };   // v12.10.22 (#1970): + options
type ListItem = {
  id: number; systemId: string; name: string; first?: string | null; last?: string | null; phone?: string | null; email?: string | null;
  dob?: string | null; zip?: string | null; externalId?: string | null; consent?: string | null; consentAt?: string | null; consentBy?: string | null;
  sharedWith: number; lastCallAt?: string | null; lastCallRef?: string | null; callCount: number; createdSource: string; createdBy?: string | null;   // v12.10.8 (#1223)
  importSource?: string | null;   // v12.10.17.1 (#1791)
  phoneType?: string | null;   // v12.10.17 (#1746 I14)
  // v12.10.21 (#1930 #1931 #1941 #1919)
  callerType?: string | null; preferredLanguage?: string | null; mode?: string | null; source?: string | null;
  callers?: { name?: string | null; relation?: string | null }[]; linkCheck?: boolean;
};
type ListResponse = { total: number; shown: number; capped: boolean; callerLabel: string; subjectLabel: string; fields: FieldDef[]; items: ListItem[] };
// v12.10.21 (#1930 D12 / #1840 R2 R4): the call that confirmed a field (the tick), "caller gave another detail", heard on a voicemail.
type Confirm = { callRef?: string | null; at?: string | null } | null;
type FieldRow = { token: string; label: string; type: string; section?: string; place?: string | null; value?: string | null; extra: boolean; options?: string[] | null;   // v12.10.22 (#1970)
  confirmed?: Confirm; otherDetail?: { value?: string | null; callRef?: string | null; at?: string | null } | null; heardOnly?: boolean };
type CallRow = { id: number; reference?: string | null; startedAt: string; durationSeconds?: number | null; outcome?: string | null; rule: string; linkCheck?: boolean };
type CallerRowT = { name?: string | null; relation?: string | null; phone?: string | null; confirmed?: boolean; callRef?: string | null; at?: string | null };   // v12.10.21 (#1941)
type HistRow = { id: number; at: string; kind: string; actorType: string; actor?: string | null; callRef?: string | null; field?: string | null;
  oldValue?: string | null; newValue?: string | null; consentKey?: string | null; note?: string | null };
type LinkRow = { id: number; systemId: string; name: string; first?: string | null; relation: string; back?: string | null; status: string };
type AddrParts = { address1: string; address2: string; city: string; state: string; zip: string };
// v12.10.17 (#1746 #1777): Phone 1-3, the verified count per phone, where the contact came from, the ID check's caller type / language.
type PhoneRow = { slot: number; phone: string; type?: string | null; primary: boolean; verifiedCount: number; lastVerifiedAt?: string | null; lastVerifiedCallRef?: string | null;
  callback?: boolean; useCount?: number };   // v12.10.21 (#1931 D7, U4)
type SourceInfo = { kind: string; display?: string | null; importSource?: string | null; importFile?: string | null; importedAt?: string | null; createdCallRef?: string | null; createdAt?: string | null };
export type CallerTypeOpt = { key: string; name: string; color?: string | null; icon?: string | null; enabled?: boolean; mode?: string | null };
type Options = { callerTypes: CallerTypeOpt[]; languages: string[]; relations?: string[]; maxPhones?: number; maxCallers?: number };
type PhoneDraft = { phone: string; type: string; primary: boolean; callback: boolean };
const MAX_PHONES = 4;   // v12.10.21 (D6): Phone 1-4
const UNCLASSIFIED = '#64748B';   // D1: no caller type = the grey Unclassified person (the Messages slate)
type Detail = {
  id: number; systemId: string; status: string; mergedInto?: string | null; name: string; first?: string | null; phone?: string | null; email?: string | null; sharedWith: number;
  consent?: string | null; consentAt?: string | null; createdSource: string; createdAt: string; lastCallAt?: string | null; callCount: number;
  callerLabel: string; subjectLabel: string; fields: FieldRow[]; calls: CallRow[]; history: HistRow[];
  externalId?: string | null; address?: Partial<Record<keyof AddrParts, string | null>>; links?: LinkRow[];
  phones?: PhoneRow[]; callerType?: string | null; preferredLanguage?: string | null; source?: SourceInfo;   // v12.10.17 (#1746 #1777)
  // v12.10.21 (#1946 #1941 #1919 D8)
  mode?: string | null; fullName?: string | null; fullNameConfirmed?: Confirm; callers?: CallerRowT[]; linkCheck?: { callRef?: string | null; at?: string | null } | null;
  preferredName?: { first?: string | null; last?: string | null } | null;   // B6 (#2027)
};
type Draft = { phone: string; email: string; fields: Record<string, string>; addr: AddrParts; consent: '' | 'given' | 'declined'; consentNote: string;
  phones: PhoneDraft[]; callerType: string; preferredLanguage: string;   // v12.10.17 (#1746 #1777)
  callers: { name: string; relation: string; phone: string }[] };   // v12.10.21 (#1941)
const FULLNAME = 'contact.fullName';
// B6 (#2027): the name in the preferred language, one per name part (contact-book field tokens - typed by staff, never filled from a call)
const PREF_FIRST = 'contact.firstNamePreferred';
const PREF_LAST = 'contact.lastNamePreferred';   // v12.10.21 (D8): office caller types have one Full name
type Mode = null | 'edit' | 'consent' | 'link' | 'merge' | 'text' | 'delete';   // v12.10.11.1 (#1489): + delete

const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const EXT = 'contact.externalId';
const ADDR_KEYS: (keyof AddrParts)[] = ['address1', 'address2', 'city', 'state', 'zip'];
const EMPTY_ADDR: AddrParts = { address1: '', address2: '', city: '', state: '', zip: '' };
/** v12.10.8 (#1221): the address's ZIP part is its own token (Address ZIP) - never subject.zip, which calls match on. */
const addrTok = (k: keyof AddrParts) => (k === 'zip' ? 'subject.addressZip' : `subject.${k}`);
export const RELATIONS = ['Parent', 'Child', 'Guardian', 'Ward', 'Caregiver', 'Cared for', 'Spouse', 'Relative', 'Authorized representative', 'Represented'];
/** The system fields the prototype places by hand (S31) - everything else from the server is Custom. */
const SYS_FALLBACK: FieldDef[] = [
  { token: 'subject.firstName', label: 'First name', type: 'name', identity: false, section: 'system', place: 'first' },
  { token: 'subject.lastName', label: 'Last name', type: 'name', identity: false, section: 'system', place: 'last' },
  { token: 'subject.dob', label: 'Date of birth', type: 'date', identity: false, section: 'system', place: 'dob' },
  { token: 'subject.zip', label: 'ZIP code', type: 'zip', identity: false, section: 'system', place: 'zip' },   // v12.10.8 (#1221 S48)
  { token: 'subject.address', label: 'Address', type: 'address', identity: false, section: 'system', place: 'address' },
  { token: EXT, label: 'External ID', type: 'text', identity: false, section: 'system', place: 'externalId' },
];

// ── formatting ─────────────────────────────────────────────────────────────────────────────────────────────────
function initials(name: string): string {
  const w = name.trim().split(/\s+/).filter(Boolean);
  if (w.length === 0) return '';
  return ((w[0][0] ?? '') + (w.length > 1 ? w[w.length - 1][0] : '')).toUpperCase();
}
function isoDate(v?: string | null): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((v ?? '').trim());
  return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null;
}
export function fmtDob(v?: string | null): string {
  const d = isoDate(v);
  return d ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : (v ?? '');
}
function dobForEdit(v?: string | null): string {
  const d = isoDate(v);
  return d ? `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}` : (v ?? '');
}
/** #1187: the date field opens the number keypad, so the slashes are put in as the digits are typed. */
export function dobMask(raw: string): string {
  if (/[a-z]/i.test(raw)) return raw;            // a pasted "Jan 5, 1994" is left for the server to read
  const d = raw.replace(/\D/g, '').slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
}
function fmtWhen(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  const day = d.toLocaleDateString('en-US', { weekday: 'short' });
  const md = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const t = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  return `${day} · ${md} · ${t}`;
}
function fmtFull(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  return `${d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} · ${d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}`;
}
/** CR-4: counts show up to 99, then "99+". */
export function capCount(n: number): string { return n > 99 ? '99+' : String(n); }
function callsLabel(n: number): string { return `${capCount(n)} call${n === 1 ? '' : 's'}`; }
/** v12.10.17 (#1746 I14): "Mobile" for "mobile"; '' for none. */
export function phoneTypeLabel(t?: string | null): string { return PHONE_TYPES.find(p => p.value === (t ?? '').toLowerCase())?.label ?? ''; }
/** v12.10.17 (#1777): "English" for "en" (the browser's own names), the code when it has none. */
export function languageName(code?: string | null): string {
  const c = (code ?? '').trim();
  if (!c) return '';
  if (/^zh(-cn|-hans)?$/i.test(c)) return 'Chinese Mandarin';   // B6 (#2027 / Q6): the product's name for zh (Simplified, zh-CN)
  try { return new Intl.DisplayNames(['en'], { type: 'language' }).of(c) ?? c.toUpperCase(); } catch { return c.toUpperCase(); }
}
function sourceLine(s?: SourceInfo): string {
  if (!s) return '';
  if (s.importSource) {
    const parts = [`Import from ${s.importSource}`];
    if (s.importedAt) parts.push(new Date(s.importedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }));
    if (s.importFile) parts.push(s.importFile);
    if (s.kind === 'call') parts.push(s.createdCallRef ? `first added on call #${s.createdCallRef}` : 'first added on a call');
    else if (s.kind === 'staff') parts.push('first added by hand');
    return parts.join(' · ');
  }
  return s.kind === 'call' ? (s.createdCallRef ? `Added on call #${s.createdCallRef}` : 'Added on a call') : s.kind === 'staff' ? 'Added by hand' : s.kind === 'import' ? 'Import' : '';
}
function showValue(f: { type: string; value?: string | null }): string {
  if (!f.value) return '';
  if (f.type === 'date') return fmtDob(f.value);
  if (f.type === 'phone') return maskPhone(f.value);
  return f.value;
}
export function addressLine(a?: Partial<Record<keyof AddrParts, string | null>> | null): string {
  if (!a) return '';
  const p = (k: keyof AddrParts) => (a[k] ?? '').trim();
  const sz = [p('state'), p('zip')].filter(Boolean).join(' ');
  return [p('address1'), p('address2'), p('city'), sz].filter(Boolean).join(', ');
}
function byWho(by?: string | null): string { return !by ? '' : by.startsWith('on ') ? by : `by ${by}`; }
/** #1180: the prototype's consent tooltip. */
export function consentTip(state?: string | null, at?: string | null, by?: string | null): string {
  const when = [at ? fmtFull(at) : '', byWho(by)].filter(Boolean).join(' · ');
  if (state === 'given') return `Text consent given${when ? ' - ' + when : ''}. The AI won't ask again.`;
  if (state === 'declined') return `Declined texts${when ? ' - ' + when : ''}. No texts are sent.`;
  return 'Text consent not recorded - The AI asks on the next call if a text is offered.';
}
function sharedTip(n: number): string { return `Shared number - ${n} more ${n === 1 ? 'person uses' : 'people use'} this number.`; }
function errText(e: unknown, fallback: string): string {
  // v12.10.9.4 (#1379): a refused call (403) is "no access", never "the server did not answer".
  if (e instanceof ApiError && e.status === 403) return 'you don’t have access to Contacts - ask your practice admin';
  if (e instanceof ApiError) {
    const b = e.body as { message?: string } | null;
    if (b?.message) return b.message;
  }
  return fallback;
}
function inputModeFor(type: string): React.HTMLAttributes<HTMLInputElement>['inputMode'] {
  return type === 'date' || type === 'zip' ? 'numeric' : type === 'phone' ? 'tel' : type === 'email' ? 'email' : type === 'number' ? 'decimal' : undefined;
}

// ── icons ──────────────────────────────────────────────────────────────────────────────────────────────────
function Ico({ d, size = 16 }: { d: ReactNode; size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{d}</svg>;
}
const ISearch = () => <Ico size={18} d={<><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>} />;
const IPlus = () => <Ico d={<path d="M12 5v14M5 12h14" />} />;
const IUpload = () => <Ico d={<><path d="M12 15V3" /><path d="m7 8 5-5 5 5" /><path d="M5 21h14" /></>} />;
const IChat = () => <Ico size={13} d={<path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.4A8 8 0 1 1 21 12Z" />} />;
const IChatL = () => <Ico size={16} d={<path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.4A8 8 0 1 1 21 12Z" />} />;
const ICopy = () => <Ico size={14} d={<><rect x="9" y="9" width="12" height="12" rx="2" /><path d="M5 15V5a2 2 0 0 1 2-2h10" /></>} />;
const IPrev = () => <Ico d={<path d="m15 18-6-6 6-6" />} />;
const INext = () => <Ico d={<path d="m9 18 6-6-6-6" />} />;
const IClose = () => <Ico d={<path d="M18 6 6 18M6 6l12 12" />} />;
const IMore = () => <Ico d={<><circle cx="12" cy="5" r="1" /><circle cx="12" cy="12" r="1" /><circle cx="12" cy="19" r="1" /></>} />;
const IEdit = () => <Ico size={15} d={<><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" /></>} />;
const IPhone = ({ size = 18 }: { size?: number }) => <Ico size={size} d={<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2Z" />} />;
const ICheck = () => <Ico size={13} d={<path d="M20 6 9 17l-5-5" />} />;
const IX = () => <Ico size={13} d={<path d="M18 6 6 18M6 6l12 12" />} />;
const IDash = () => <Ico size={13} d={<path d="M6 12h12" />} />;
const IGear = () => <Ico d={<><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z" /></>} />;   // v12.10.21 (#1946)
const ICb = () => <Ico size={12} d={<><path d="M9 14 4 9l5-5" /><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11" /></>} />;   // v12.10.21 (D7): the Callback pill
const IPin = () => <Ico size={14} d={<><path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11Z" /><circle cx="12" cy="10" r="2.5" /></>} />;

/** #1180: a tooltip that opens on hover, on keyboard focus and on tap (phones). */
function Tip({ text, children, className }: { text: string; children: ReactNode; className?: string }) {
  const [on, setOn] = useState(false);
  return (
    <span className={`tipw${on ? ' on' : ''}${className ? ' ' + className : ''}`} tabIndex={0} role="note" aria-label={text}
      onClick={(e) => { e.stopPropagation(); setOn(o => !o); }} onBlur={() => setOn(false)}
      onKeyDown={(e) => { if (e.key === 'Escape' && on) { e.stopPropagation(); setOn(false); } }}>
      {children}<span className="tip" role="tooltip">{text}</span>
    </span>
  );
}

function ConsentIcon({ state, at, by }: { state?: string | null; at?: string | null; by?: string | null }) {
  const s = state === 'given' ? 'given' : state === 'declined' ? 'declined' : 'none';
  return (
    <Tip text={consentTip(state, at, by)} className={`cn ${s}`}>
      {s === 'given' && <ICheck />}{s === 'declined' && <IX />}{s === 'none' && <IDash />}
    </Tip>
  );
}

function copy(text: string, what: string) {
  void navigator.clipboard?.writeText(text).then(() => toast('success', `${what} copied.`, text), () => toast('error', 'Could not copy', text));
}

// ── v12.10.21 (#1930 #1931, D1 D2 D5 D12 D18) ──────────────────────────────────────────────────────────────────
/** D1: the avatar is the caller type's badge - its icon + colour from Personalization › Caller types, as the Messages card; none = grey person. */
function CtBadge({ ct, size = 22, small }: { ct?: CallerTypeOpt; size?: number; small?: boolean }) {
  return (
    <div className={`av avct${small ? ' sm' : ''}`} style={{ background: ct?.color || UNCLASSIFIED }} title={ct?.name ?? 'Unclassified'}>
      <CallerTypeIcon name={ct?.icon || 'User'} size={size} />
    </div>
  );
}
/** D2: the caller-type pill in its colour + icon. */
function CtPill({ ct, fallback }: { ct?: CallerTypeOpt; fallback?: string | null }) {
  if (!ct && !fallback) return null;
  const c = ct?.color || UNCLASSIFIED;
  return <span className="lab ctl" style={{ color: c, borderColor: c + '40', background: c + '12' }}><CallerTypeIcon name={ct?.icon || 'User'} size={12} />{ct?.name ?? fallback}</span>;
}
/** D12: one mark everywhere - a green tick with a tooltip; no tick = not confirmed. */
function VTick({ why }: { why: string }) {
  return <Tip text={why} className="vt"><ICheck /></Tip>;
}
function confirmTip(c?: Confirm, what = 'Confirmed by the caller'): string {
  if (!c) return '';
  return `${what}${c.callRef ? `, call ${formatReference(c.callRef)}` : ''}${c.at ? ` · ${new Date(c.at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}` : ''}`;
}
/** D5: "Import from DigiDMS" / "Merged from DigiDMS" / "Call" (/ "Added by hand"). */
function sourceShort(kind?: string | null, importSource?: string | null): string {
  const src = importSource || 'DigiDMS';
  return kind === 'import' ? `Import from ${src}` : kind === 'merged' ? `Merged from ${src}` : kind === 'staff' ? 'Added by hand' : 'Call';
}
/** D18: a phone click copies the digits only (no +1, no format) - the same as the message card and drawer. */
function copyDigits(e164: string) {
  const d = e164.replace(/\D/g, '');
  copy(d.length === 11 && d.startsWith('1') ? d.slice(1) : d, 'Phone number');
}

// ── page ──────────────────────────────────────────────────────────────────────────────────────────────────
export default function ContactsPage() {
  const qc = useQueryClient();
  const [q, setQ] = useState('');
  const [debounced, setDebounced] = useState('');
  const [openId, setOpenId] = useState<number | null>(null);
  const [adding, setAdding] = useState(false);
  const [importing, setImporting] = useState(false);   // v12.10.17 (#1746)
  const [settingsOpen, setSettingsOpen] = useState(false);   // v12.10.21 (#1946 D14)
  useEffect(() => { const t = setTimeout(() => setDebounced(q.trim()), 250); return () => clearTimeout(t); }, [q]);

  const { canOpen, hasAccess, me: accessMe } = useAccess();
  const canImport = hasAccess('contacts', 'edit');   // v12.10.17 (#1746): the import adds and edits contacts
  const noAccess = !!accessMe && !canOpen('contacts');   // v12.10.9.4 (#1379): typed /contacts without the right
  const list = useQuery({
    enabled: !noAccess,
    queryKey: ['contacts', debounced],
    queryFn: () => api.get<ListResponse>(`/t2/contacts${debounced ? `?q=${encodeURIComponent(debounced)}` : ''}`),
    placeholderData: (prev) => prev,
  });
  const data = list.data;
  const items = data?.items ?? [];
  // v12.10.21 (#1930 D1): caller types (icon + colour) for the cards' avatars and pills
  const optsQ = useQuery({ enabled: !noAccess, queryKey: ['contacts-options'], queryFn: () => api.get<Options>('/t2/contacts/options'), staleTime: 60_000, retry: false });
  const ctFind = (key?: string | null) => (key ? optsQ.data?.callerTypes.find(t => t.key === key) : undefined);
  const ids = items.map(i => i.id);
  const idx = openId == null ? -1 : ids.indexOf(openId);

  function refresh() { void qc.invalidateQueries({ queryKey: ['contacts'] }); }

  // v12.10.9.4 (#1379): no Contacts right -> say so, nothing else (no list, no Add contact).
  if (noAccess) return (
    <div className="cbk"><div className="wrap"><div className="stick"><p className="eyebrow">CONTACTS</p></div>
      <div className="empty" role="status">You don’t have access to Contacts - ask your practice admin.</div></div></div>
  );

  return (
    <div className="cbk">
      <div className="wrap">
        <div className="stick">
          <p className="eyebrow">CONTACTS</p>
          <div className="head">
            <div className="count">{data ? data.total : '…'}<small>{data?.total === 1 ? 'person' : 'people'}</small></div>
            <span className="sp" />
            <div className="hact">
              {/* v12.10.21 (#1946 D14): the gear before Import opens Contact book settings (680px drawer) */}
              <button type="button" className="btn gear" title="Contact book settings" aria-label="Contact book settings"
                onClick={() => { setOpenId(null); setAdding(false); setImporting(false); setSettingsOpen(true); }}><IGear /></button>
              {/* v12.10.17 (#1746 I1): Import is live - manual upload, no automatic sync. */}
              <button type="button" className="btn imp" disabled={!canImport} title={canImport ? 'Import patients from a DigiDMS export (or any patient file)' : 'Importing needs Contacts › Add and edit'}
                onClick={() => { setOpenId(null); setAdding(false); setSettingsOpen(false); setImporting(true); }}><IUpload /><span className="lbl">Import</span></button>
              <button type="button" className="btn pri" onClick={() => { setOpenId(null); setAdding(true); }}><IPlus />Add contact</button>
            </div>
          </div>
          <label className="search">
            <ISearch />
            <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search any mix - name, phone, DOB, ZIP, ID" aria-label="Search contacts" />
          </label>
          {/* v12.10.22 (#1961): what is being searched, as a chip with x - and Clear all - the way Messages shows it */}
          {q.trim() && (
            <div className="schips">
              <span className="schip">Search: {q.trim()}<button type="button" aria-label="Clear the search" title="Clear the search" onClick={() => setQ('')}>×</button></span>
              <button type="button" className="sclear" onClick={() => setQ('')}>Clear all</button>
            </div>
          )}
        </div>

        {list.isError && <div className="loaderr">Contacts could not be loaded - {errText(list.error, 'the server did not answer')}. <button type="button" className="btn sm" onClick={() => list.refetch()}>Try again</button></div>}
        {data && data.total === 0 && <div className="empty">Nobody here yet. Contacts appear as calls come in, or add one by hand.</div>}
        {data && data.total > 0 && items.length === 0 && <div className="empty">No contacts match “{debounced}”. Try fewer words, or search by phone number.</div>}
        {items.map(c => (
          <ContactCard key={c.id} c={c} ct={ctFind(c.callerType)} selected={c.id === openId} onOpen={() => { setAdding(false); setOpenId(c.id); }} />
        ))}
        {data?.capped && <p className="note">Showing the {data.shown} most recent - search to find anyone else.</p>}
      </div>

      {settingsOpen && <ContactBookSettingsDrawer onClose={() => setSettingsOpen(false)} onSaved={() => { void qc.invalidateQueries({ queryKey: ['contacts-options'] }); refresh(); }} />}
      {importing && (
        <ImportDrawer callerTypes={optsQ.data?.callerTypes ?? []} customFields={(data?.fields ?? []).filter(f => (f.section ?? 'custom') === 'custom' && f.type !== 'address')}
          onClose={() => setImporting(false)} onDone={() => { setImporting(false); refresh(); }} />
      )}
      {(openId != null || adding) && (
        <ContactDrawer
          key={adding ? 'new' : openId}
          id={adding ? null : openId}
          fieldsForNew={data?.fields?.length ? data.fields : SYS_FALLBACK}
          subjectLabel={data?.subjectLabel ?? 'Patient'}
          callerLabel={data?.callerLabel ?? 'Caller'}
          canPrev={idx > 0} canNext={idx >= 0 && idx < ids.length - 1}
          onPrev={() => idx > 0 && setOpenId(ids[idx - 1])}
          onNext={() => idx >= 0 && idx < ids.length - 1 && setOpenId(ids[idx + 1])}
          onClose={() => { setOpenId(null); setAdding(false); }}
          onCreated={(nid) => { setAdding(false); setOpenId(nid); refresh(); }}
          onChanged={refresh}
          onOpenOther={(nid) => { setAdding(false); setOpenId(nid); }}
          listItems={data?.items ?? []}
        />
      )}
    </div>
  );
}

function ContactCard({ c, ct, selected, onOpen }: { c: ListItem; ct?: CallerTypeOpt; selected: boolean; onOpen: () => void }) {
  // v12.10.21 (#1930 #1931 D1 D2 D9): caller-type badge as the avatar, the caller-type pill only (no Contact / Patient / Caller pills)
  const callers = (c.callers ?? []).filter(x => x.name || x.relation);
  return (
    // A div with the button role: the consent and +N tooltips inside it are focusable, which a <button> may not contain.
    <div role="button" tabIndex={0} className={`ccard${selected ? ' sel' : ''}`} onClick={onOpen}
      onKeyDown={(e) => { if ((e.key === 'Enter' || e.key === ' ') && e.target === e.currentTarget) { e.preventDefault(); onOpen(); } }}>
      <CtBadge ct={ct} />
      <div className="bd2">
        <div className="l1">
          <span className={`nm${c.name ? '' : ' na'}`}>{c.name || 'No name yet'}</span>
          <ConsentIcon state={c.consent} at={c.consentAt} by={c.consentBy} />
          <CtPill ct={ct} fallback={c.callerType} />
          {c.preferredLanguage && <span className="lab lang" title="Preferred language - the language the latest call ended in">{languageName(c.preferredLanguage)}</span>}{/* v12.10.22 (#1964) */}
          {c.linkCheck && <span className="lab chk" title="A caller said the name was not right on a linked call - check this contact">CHECK</span>}
        </div>
        <div className="r1">
          {c.phone ? <>{maskPhone(c.phone)}{phoneTypeLabel(c.phoneType) ? ` · ${phoneTypeLabel(c.phoneType)}` : ''}{/* v12.10.17 (#1746 I14) */}</> : <span className="dim">No phone</span>}
          {c.sharedWith > 0 && <Tip text={sharedTip(c.sharedWith)} className="plus">+{c.sharedWith}</Tip>}
        </div>
        <div className="l2">
          <span className="pr"><i>System ID</i>{c.systemId}</span>
          {c.dob && <><span className="sep">·</span><span className="pr"><i>DOB</i>{fmtDob(c.dob)}</span></>}
          {c.zip && <><span className="sep">·</span><span className="pr"><i>ZIP</i>{c.zip}</span></>}
          {c.externalId && <><span className="sep">·</span><span className="pr"><i>External ID</i>{c.externalId}</span></>}
          {callers.length > 0 && <><span className="sep">·</span><span className="pr"><i>Caller</i>{callers.map(x => [x.name, x.relation].filter(Boolean).join(' · ')).join(', ')}</span></>}
        </div>
        <div className="r2">
          {c.lastCallAt ? <span>{fmtWhen(c.lastCallAt)}</span> : <span>{c.createdSource === 'staff' ? `Added by ${c.createdBy || 'staff'}` : c.source === 'import' || c.createdSource === 'import' ? `Import from ${c.importSource || 'a file'}` : c.source === 'merged' ? `Merged from ${c.importSource || 'DigiDMS'}` : 'Added on call'}</span>}{/* v12.10.17.1 (#1791) */}
          {c.callCount > 0 && <span className="calls" title="Opening these calls in Messages comes with a later phase"><IChat />{callsLabel(c.callCount)}</span>}
        </div>
      </div>
      {/* #1185: the Messages card's open affordance - fills on hover, hidden below 760px (Messages rule P). */}
      <span className="chev" aria-hidden="true">&gt;</span>
    </div>
  );
}

// ── drawer ────────────────────────────────────────────────────────────────────────────────────────────────
type DrawerProps = {
  id: number | null; fieldsForNew: FieldDef[]; subjectLabel: string; callerLabel: string;
  canPrev: boolean; canNext: boolean; onPrev: () => void; onNext: () => void; onClose: () => void;
  onCreated: (id: number) => void; onChanged: () => void; onOpenOther: (id: number) => void; listItems: ListItem[];
};

function draftFrom(rows: FieldRow[], d?: Detail): Draft {
  const fields: Record<string, string> = {};
  for (const f of rows) {
    if (f.type === 'address') continue;
    fields[f.token] = f.type === 'date' ? dobForEdit(f.value) : (f.value ?? '');
  }
  const a = d?.address ?? {};
  // v12.10.17 (#1746 I7): always the phone rows in Edit; the Primary is the one starred. v12.10.21 (D6 D7): Phone 1-4 + the Callback tick.
  const phones: PhoneDraft[] = Array.from({ length: MAX_PHONES }, (_, i) => i + 1).map(slot => {
    const r = d?.phones?.find(x => x.slot === slot);
    return { phone: r?.phone ?? (slot === 1 && !d?.phones?.length ? d?.phone ?? '' : ''), type: r?.type ?? '', primary: r ? r.primary : slot === 1 && !d?.phones?.some(x => x.primary),
      callback: !!r?.callback };
  });
  if (d?.fullName != null) fields[FULLNAME] = d.fullName ?? '';
  fields[PREF_FIRST] = d?.preferredName?.first ?? '';   // B6 (#2027)
  fields[PREF_LAST] = d?.preferredName?.last ?? '';
  return {
    phone: d?.phone ?? '', email: d?.email ?? '', fields,
    addr: { address1: a.address1 ?? '', address2: a.address2 ?? '', city: a.city ?? '', state: a.state ?? '', zip: a.zip ?? '' },
    consent: '', consentNote: '',
    phones, callerType: d?.callerType ?? '', preferredLanguage: d?.preferredLanguage ?? '',
    callers: (d?.callers ?? []).map(x => ({ name: x.name ?? '', relation: x.relation ?? '', phone: x.phone ?? '' })),   // v12.10.21 (#1941)
  };
}

function ContactDrawer(p: DrawerProps) {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const isNew = p.id == null;
  const detail = useQuery({ queryKey: ['contact', p.id], queryFn: () => api.get<Detail>(`/t2/contacts/${p.id}`), enabled: !isNew });
  const d = detail.data;
  // #1184: ONE edit at a time - Details edit, Record consent, Link person, Merge and Send text close each other.
  const [mode, setMode] = useState<Mode>(isNew ? 'edit' : null);
  const editing = mode === 'edit';
  const fieldRows: FieldRow[] = isNew ? p.fieldsForNew.map(f => ({ token: f.token, label: f.label, type: f.type, section: f.section, place: f.place, value: '', extra: false })) : (d?.fields ?? []);
  const [draft, setDraft] = useState<Draft>(() => draftFrom(fieldRows));
  const [initial, setInitial] = useState<Draft>(() => draftFrom(fieldRows));
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [saving, setSaving] = useState(false);
  const [menu, setMenu] = useState(false);
  const { hasAccess } = useAccess();   // v12.10.11.1 (#1489): Contacts › Delete
  const [texting, setTexting] = useState(false);
  const [textErr, setTextErr] = useState<string | null>(null);
  const bodyRef = useRef<HTMLDivElement>(null);
  // v12.10.17 (#1777): the workflow caller types and the practice's languages - Edit offers only these.
  const opts = useQuery({ queryKey: ['contacts-options'], queryFn: () => api.get<Options>('/t2/contacts/options'), staleTime: 60_000, retry: false });
  const callerTypes = opts.data?.callerTypes ?? [];
  const languages = opts.data?.languages ?? [];
  const ctOf = (key?: string | null) => callerTypes.find(t => t.key === key);
  const relations = opts.data?.relations ?? ['Daughter', 'Son', 'Spouse', 'Parent', 'Guardian', 'Caregiver', 'Employee', 'Other'];   // D10 - the server's list wins

  const sys = (place: string): FieldRow => fieldRows.find(f => f.place === place) ?? { ...SYS_FALLBACK.find(f => f.place === place)!, value: null, extra: false };
  // v12.10.8 (#1227): a system field the server does not list was switched Off in Vocabulary - not drawn (before the first load, all are).
  const has = (place: string): boolean => fieldRows.length === 0 || fieldRows.some(f => f.place === place);
  const customRows = fieldRows.filter(f => (f.section ?? 'custom') === 'custom' && f.type !== 'address');
  // v12.10.21 (D8): an office caller type has ONE Full name (from its set-up in Contact book settings)
  const isOffice = (d?.mode ?? ctOf(draft.callerType)?.mode) === 'office' || (!!d?.fullName && !sys('first').value && !sys('last').value);

  function open(m: Mode) {
    if (m === 'edit') {
      if (!d) return;
      const dr = draftFrom(d.fields, d);
      setDraft(dr); setInitial(dr); setErrors({});
    }
    setMenu(false); setTextErr(null); setMode(m);
  }
  function cancelEdit() { if (isNew) p.onClose(); else { setMode(null); setErrors({}); } }

  function validate(): Record<string, string> {
    const e: Record<string, string> = {};
    // v12.10.17 (#1746 I7): Phone 1-3 - at least one, each a 10-digit number, no number twice.
    const filled = draft.phones.map((ph, i) => ({ ...ph, slot: i + 1 })).filter(ph => ph.phone.trim());
    if (filled.length === 0) e.phone1 = 'Enter a phone number.';
    for (const ph of filled) {
      if (phoneError(ph.phone)) e[`phone${ph.slot}`] = 'Enter a 10-digit US or Canada number.';
      else if (filled.some(o => o.slot < ph.slot && o.phone.replace(/\D/g, '').slice(-10) === ph.phone.replace(/\D/g, '').slice(-10))) e[`phone${ph.slot}`] = 'This number is already on this contact.';
    }
    if (draft.email.trim() && !EMAIL_RX.test(draft.email.trim())) e.email = 'Enter an email like name@example.com.';
    const hasAny = Object.values(draft.fields).some(v => v.trim()) || ADDR_KEYS.some(k => draft.addr[k].trim());   // v12.10.21: the office Full name counts
    if (!hasAny) e[sys('first').token] = 'Enter at least a first or last name.';
    for (const f of fieldRows) {
      const v = (draft.fields[f.token] ?? '').trim();
      if (!v) continue;
      if (f.type === 'zip' && v.replace(/\D/g, '').length < 5) e[f.token] = 'Enter a 5-digit ZIP.';
      if (f.type === 'date' && !/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(v) && !/^\d{4}-\d{2}-\d{2}$/.test(v)) e[f.token] = 'Enter a date like 07/04/1980.';
      if (f.type === 'email' && !EMAIL_RX.test(v)) e[f.token] = 'Enter an email like name@example.com.';
      if (f.type === 'phone' && phoneError(v)) e[f.token] = 'Enter a 10-digit US or Canada number.';
      if (f.type === 'number' && !/^-?\d+(\.\d+)?$/.test(v.replace(/,/g, ''))) e[f.token] = 'Enter a number.';
    }
    if (draft.addr.zip.trim() && draft.addr.zip.replace(/\D/g, '').length < 5) e['subject.addressZip'] = 'Enter a 5-digit ZIP.';
    if ((draft.fields[EXT] ?? '').trim().length > 64) e[EXT] = 'External ID is 64 characters at most.';
    return e;
  }

  function focusFirstError(e: Record<string, string>) {
    const first = Object.keys(e)[0];
    if (!first) return;
    setTimeout(() => { (bodyRef.current?.querySelector(`[data-k="${CSS.escape(first)}"]`) as HTMLInputElement | null)?.focus(); }, 0);
  }

  async function save() {
    const e = validate();
    setErrors(e);
    if (Object.keys(e).length) { focusFirstError(e); return; }
    setSaving(true);
    // Only what changed is sent - a value shown from the caller's side is not re-written as a "change" (#1189).
    const fields: Record<string, string> = {};
    for (const [k, v] of Object.entries(draft.fields)) if (isNew ? v.trim() : v.trim() !== (initial.fields[k] ?? '').trim()) fields[k] = v.trim();
    for (const k of ADDR_KEYS) if (isNew ? draft.addr[k].trim() : draft.addr[k].trim() !== initial.addr[k].trim()) fields[addrTok(k)] = draft.addr[k].trim();
    // v12.10.17 (#1746 I7): the three phone rows go as one list when anything in them changed; the Primary is the starred
    // filled row (the first filled one when the star sits on an empty row).
    const filled = draft.phones.map((ph, i) => ({ slot: i + 1, phone: ph.phone.trim(), type: ph.type || null, primary: ph.primary, callback: ph.callback })).filter(ph => ph.phone);   // v12.10.21 (D7)
    if (filled.length && !filled.some(ph => ph.primary)) filled[0].primary = true;
    const phonesChanged = isNew || JSON.stringify(draft.phones) !== JSON.stringify(initial.phones);
    const body = {
      phone: filled.find(ph => ph.primary)?.phone ?? null,
      email: isNew || draft.email.trim() !== initial.email.trim() ? draft.email.trim() : null,
      fields, consent: draft.consent || null, consentNote: draft.consentNote || null,
      phones: phonesChanged ? filled : null,
      callerType: isNew ? (draft.callerType || null) : draft.callerType !== initial.callerType ? draft.callerType : null,                       // v12.10.17 (#1777): '' clears
      preferredLanguage: isNew ? (draft.preferredLanguage || null) : draft.preferredLanguage !== initial.preferredLanguage ? draft.preferredLanguage : null,
      // v12.10.21 (#1941): the caller rows, when anything in them changed
      callers: JSON.stringify(draft.callers) !== JSON.stringify(initial.callers) ? draft.callers.filter(x => x.name.trim() || x.relation) : null,
    };
    try {
      if (isNew) {
        const r = await api.post<Detail>('/t2/contacts', body);
        toast('success', 'Contact added.', `${r.name || r.systemId} · ${r.systemId}`);
        p.onCreated(r.id);
      } else {
        const r = await api.put<{ changed: number; contact: Detail }>(`/t2/contacts/${p.id}`, body);
        qc.setQueryData(['contact', p.id], r.contact);
        toast('success', r.changed ? 'Changes saved.' : 'Nothing changed.');
        setMode(null); p.onChanged();
      }
    } catch (err) {
      const b = err instanceof ApiError ? (err.body as { errors?: Record<string, string> } | null) : null;
      if (b?.errors) { setErrors(b.errors); focusFirstError(b.errors); }
      toast('error', isNew ? 'Contact not added' : 'Changes not saved', errText(err, 'The server did not accept the change - nothing was saved.'));
    } finally { setSaving(false); }
  }

  async function sendText(to: string, body: string) {
    if (!d) return;
    setTexting(true); setTextErr(null);
    try {
      const r = await api.post<{ sent: boolean; reason?: string | null; contact: Detail }>(`/t2/contacts/${d.id}/text`, { to, body });
      qc.setQueryData(['contact', d.id], r.contact);
      if (r.sent) { setMode(null); toast('success', 'Text sent.', "Logged in this contact's History."); }
      else { setTextErr(`The text was not sent - ${r.reason ?? 'it could not be delivered'}. It is logged in History as not sent.`); toast('warning', 'Text not sent', r.reason ?? ''); }
    } catch (e) {
      setTextErr('The text could not be sent. Check the number and try again.');
      toast('error', 'Could not send', errText(e, 'The message was not sent.'));
    } finally { setTexting(false); }
  }

  // Esc closes (or cancels an edit); Ctrl+Enter saves (CR-5).
  useEffect(() => {
    function onKey(ev: KeyboardEvent) {
      if (ev.defaultPrevented) return;
      if (ev.key === 'Escape') { ev.preventDefault(); if (menu) setMenu(false); else if (editing) cancelEdit(); else if (mode) setMode(null); else p.onClose(); }
      else if (ev.key === 'Enter' && (ev.ctrlKey || ev.metaKey) && editing && !saving) { ev.preventDefault(); void save(); }
      else if (!mode && !['INPUT', 'TEXTAREA', 'SELECT'].includes((ev.target as HTMLElement)?.tagName)) {
        if (ev.key === 'ArrowLeft' && p.canPrev) p.onPrev();
        if (ev.key === 'ArrowRight' && p.canNext) p.onNext();
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  });

  const name = isNew ? 'New contact' : (d?.name || 'No name yet');
  const setField = (tok: string, v: string) => setDraft(x => ({ ...x, fields: { ...x.fields, [tok]: v } }));
  // B6 (#2027): which preferred-language name line is being typed in, and its text until Enter / click away (Esc drops it)
  const [prefEdit, setPrefEdit] = useState<{ tok: string; val: string } | null>(null);
  const setAddr = (k: keyof AddrParts, v: string) => setDraft(x => ({ ...x, addr: { ...x.addr, [k]: v } }));
  const setPhone = (i: number, patch: Partial<PhoneDraft>) => setDraft(x => ({ ...x, phones: x.phones.map((ph, j) => (j === i ? { ...ph, ...patch }
    : patch.primary ? { ...ph, primary: false } : patch.callback ? { ...ph, callback: false } : ph)) }));   // v12.10.21 (D7): one Callback
  const setCaller = (i: number, patch: Partial<Draft['callers'][number]>) => setDraft(x => ({ ...x, callers: x.callers.map((c, j) => (j === i ? { ...c, ...patch } : c)) }));
  async function clearCheck() {   // v12.10.21 (#1919 C3): staff checked the link
    if (!d) return;
    try {
      const r = await api.put<{ changed: number; contact: Detail }>(`/t2/contacts/${d.id}`, { clearLinkCheck: true });
      qc.setQueryData(['contact', p.id], r.contact); p.onChanged(); toast('success', 'CHECK cleared.');
    } catch (err) { toast('error', 'Not cleared', errText(err, 'Nothing was saved.')); }
  }
  // v12.10.17 (#1746 #1777): what the view shows for Phone 1-4 and the verified count
  const phoneRows: PhoneRow[] = d?.phones?.length ? d.phones : d?.phone ? [{ slot: 1, phone: d.phone, type: null, primary: true, verifiedCount: 0 }] : [];
  const primaryRow = phoneRows.find(r => r.primary);
  const maxVerified = phoneRows.reduce((m, r) => Math.max(m, r.verifiedCount), 0);
  const ct = ctOf(d?.callerType);
  const lastConsent = d?.history.find(h => h.consentKey === 'sms' && h.kind === 'consent');
  const consentBy = lastConsent ? (lastConsent.actorType === 'call' ? `on call #${lastConsent.callRef}` : (lastConsent.actor || 'staff')) : null;

  // Plain render functions, not components: a component declared inside render remounts its <input> on every
  // keystroke and the field loses focus.
  // B6 (#2027, LOCKED v1.3): the text under a name box - the name in the preferred language. Not shown for English or no language.
  const prefLine = (tok: string) => {
    const lang = draft.preferredLanguage;
    if (!lang || /^en(-|$)/i.test(lang)) return null;
    const label = languageName(lang);
    const v = draft.fields[tok] ?? '';
    const han = /[\u4e00-\u9fff\u3400-\u4dbf]/.test(v);
    if (prefEdit?.tok === tok)
      return (
        <div className="pnalt">
          <input autoFocus className={/[\u4e00-\u9fff\u3400-\u4dbf]/.test(prefEdit.val) ? 'zh' : ''} value={prefEdit.val} aria-label={`${label} name`}
            onChange={e => setPrefEdit({ tok, val: e.target.value })}
            onKeyDown={e => {
              if (e.key === 'Enter') { e.preventDefault(); setField(tok, prefEdit.val.trim()); setPrefEdit(null); }
              if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); setPrefEdit(null); }
            }}
            onBlur={() => { setField(tok, prefEdit.val.trim()); setPrefEdit(null); }} />
          <span className="lab">{label} · Enter to keep, Esc to cancel</span>
        </div>
      );
    return (
      <div className="pnalt">
        {v
          ? <><span className={`t${han ? ' zh' : ''}`} title="Click to edit" role="button" tabIndex={0} onClick={() => setPrefEdit({ tok, val: v })}
              onKeyDown={e => { if (e.key === 'Enter') setPrefEdit({ tok, val: v }); }}>{v}</span><span className="lab">{label}</span></>
          : <span className="add" role="button" tabIndex={0} onClick={() => setPrefEdit({ tok, val: '' })}
              onKeyDown={e => { if (e.key === 'Enter') setPrefEdit({ tok, val: '' }); }}>+ {label}</span>}
      </div>
    );
  };
  const input = (f: FieldRow | FieldDef, full?: boolean, ph?: string, below?: ReactNode) => f.type === 'list' ? (
    // v12.10.22 (#1970): a list (choice) field - a dropdown of its practice List's entries; nothing else is accepted
    <div className={`f${full ? ' full' : ''}`} key={f.token}>
      <small>{f.label}</small>
      <select data-k={f.token} className={errors[f.token] ? 'sel-bad' : ''} value={draft.fields[f.token] ?? ''} onChange={e => setField(f.token, e.target.value)} aria-invalid={!!errors[f.token]}>
        <option value="">—</option>
        {(f.options ?? []).map(o => <option key={o} value={o}>{o}</option>)}
        {draft.fields[f.token] && !(f.options ?? []).some(o => o.toLowerCase() === (draft.fields[f.token] ?? '').toLowerCase()) && <option value={draft.fields[f.token] ?? ''}>{draft.fields[f.token]} (not in the list)</option>}
      </select>
      {errors[f.token] && <div className="err">{errors[f.token]}</div>}
    </div>
  ) : (
    <div className={`f${full ? ' full' : ''}`} key={f.token}>
      <small>{f.label}</small>
      <input data-k={f.token} className={errors[f.token] ? 'bad' : ''} value={draft.fields[f.token] ?? ''}
        placeholder={ph ?? (f.type === 'date' ? 'MM/DD/YYYY' : '')} inputMode={inputModeFor(f.type)}
        autoComplete="off"
        onChange={e => setField(f.token, f.type === 'date' ? dobMask(e.target.value) : e.target.value)} aria-invalid={!!errors[f.token]} />
      {below}
      {errors[f.token] && <div className="err">{errors[f.token]}</div>}
    </div>
  );
  const view = (label: string, value?: string | null, full?: boolean, key?: string, row?: FieldRow) => (
    <div className={`f${full ? ' full' : ''}`} key={key ?? label}><small>{label}</small>
      <div className={value ? '' : 'na'}>{value || 'Not on file'}{value && row?.confirmed && <> <VTick why={confirmTip(row.confirmed)} /></>}</div>
      {/* v12.10.21 (#1840 R2 / #1930): a different value a caller gave - the card is unchanged; R4: heard on a voicemail */}
      {row?.otherDetail && <div className="odet" title="The contact is not changed by a call - this is what the caller said">Caller gave another detail{row.otherDetail.value ? `: ${row.type === 'date' ? fmtDob(row.otherDetail.value) : row.otherDetail.value}` : ''}{row.otherDetail.callRef ? ` · call ${formatReference(row.otherDetail.callRef)}` : ''}</div>}
      {row?.heardOnly && <div className="odet">Heard on a voicemail - not verified</div>}
    </div>
  );

  return (
    <>
      <div className="dscrim" onClick={p.onClose} />
      <aside className="drawer" role="dialog" aria-modal="true" aria-label={name}>
        <div className="dnav">
          <button type="button" className="nb" disabled={isNew || !p.canPrev || !!mode} onClick={p.onPrev} aria-label="Previous contact" title="Previous contact"><IPrev /></button>
          {!isNew && d && <span className="refc">{d.systemId}<button type="button" className="cp" onClick={() => copy(d.systemId, 'System ID')} aria-label="Copy System ID" title="Copy System ID"><ICopy /></button></span>}
          {isNew && <span className="refc">New</span>}
          <button type="button" className="nb" disabled={isNew || !p.canNext || !!mode} onClick={p.onNext} aria-label="Next contact" title="Next contact"><INext /></button>
          <span className="sp" />
          <button type="button" className="xbtn" onClick={p.onClose} aria-label="Close" title="Close (Esc)"><IClose /></button>
        </div>

        <div className="dbody" ref={bodyRef}>
          {!isNew && detail.isError && <div className="db"><div className="loaderr">This contact could not be loaded - {errText(detail.error, 'the server did not answer')}.</div></div>}
          {!isNew && !d && !detail.isError && <div className="db"><p className="dim">Loading…</p></div>}
          {(isNew || d) && (
            <>
              <div className="dhead">
                <CtBadge ct={ct} />{/* v12.10.21 (#1930 D1) */}
                <div style={{ minWidth: 0 }}>
                  <h2>{name}</h2>
                  {/* #1175: External ID under the name; "Added by hand / from a call" is the first History row already. */}
                  {!isNew && d && (d.externalId
                    ? <p className="idrow">External ID <b>{d.externalId}</b><button type="button" className="cp" onClick={() => copy(d.externalId!, 'External ID')} aria-label="Copy External ID" title="Copy External ID"><ICopy /></button></p>
                    : <p className="idrow na">External ID —</p>)}
                  {isNew && <p>Phone plus a first or last name - or one other detail - is enough to save.</p>}
                </div>
              </div>
              {!isNew && d && (
                <div className="sum">
                  <div className="chips">
                    {/* v12.10.21 (D9): no status pill - only a merged contact says where it went */}
                    {d.status !== 'active' && <span className="chip no">Merged into {d.mergedInto}</span>}
                    <Tip text={consentTip(d.consent, d.consentAt, consentBy)}>
                      {d.consent === 'given' && <span className="chip ok"><ICheck />Consent available</span>}
                      {d.consent === 'declined' && <span className="chip bad"><IX />Consent declined</span>}
                      {!d.consent && <span className="chip no"><IDash />No consent</span>}
                    </Tip>
                    {/* v12.10.21 (D2 D5): the caller-type pill; Source · Import from DigiDMS / Merged from DigiDMS / Call */}
                    <CtPill ct={ct} fallback={d.callerType} />
                    {d?.preferredLanguage && <span className="lab lang" title="Preferred language - the language the latest call ended in">{languageName(d.preferredLanguage)}</span>}{/* v12.10.22 (#1964) */}
                    <span className="chip no" title="Where this contact came from">Source · {sourceShort(d.source?.display, d.source?.importSource)}</span>
                    {maxVerified > 0 && <span className="chip vfy" title="Calls that confirmed this person on this phone - used by the ID check">Verified ×{maxVerified}</span>}
                    {/* v12.10.21 (#1919 C3): a caller said NO to the name at Confirm on a call linked to this contact */}
                    {d.linkCheck && <span className="chip chk" title={`On call ${d.linkCheck.callRef ? formatReference(d.linkCheck.callRef) : ''} the caller said the name was not right - the call stays linked. Check it, then clear.`}>CHECK{d.linkCheck.callRef ? ` · ${formatReference(d.linkCheck.callRef)}` : ''}
                      <button type="button" className="chkx" onClick={() => void clearCheck()} title="The link is right - clear CHECK" aria-label="Clear CHECK"><IX /></button></span>}
                  </div>
                  <div className="sumline">
                    {/* v12.10.21 (D4): "Primary +1 (…) · Mobile · Last call … · #ref · N calls" - no colons */}
                    <span>{d.phone ? <><span className="pnewi">Primary</span> <button type="button" className="phc" onClick={() => copyDigits(d.phone!)} title="Copy the number (digits only)">{maskPhone(d.phone)}</button>{phoneTypeLabel(primaryRow?.type) && <span className="dim"> · {phoneTypeLabel(primaryRow?.type)}</span>}</> : <span className="dim">No phone</span>}</span>
                    {d.sharedWith > 0 && <Tip text={sharedTip(d.sharedWith)} className="plus">+{d.sharedWith}</Tip>}
                    {d.lastCallAt && <><span className="sep">·</span><span className="lastl">Last call {fmtWhen(d.lastCallAt)}{d.calls[0]?.reference ? ` · ${formatReference(d.calls[0].reference)}` : ''}{/* v12.10.17 (#1773) */} · {callsLabel(d.callCount)}</span></>}
                  </div>
                </div>
              )}
              {/* #1177: the action row - Call (coming later) · Send text · ⋮ */}
              {!isNew && d && d.status === 'active' && (
                <div className="acts">
                  <button type="button" className="btn pri" disabled title={d.phone ? 'Calling from the browser comes later' : 'No phone on file'}><IPhone size={16} />Call</button>
                  <button type="button" className={`btn${mode === 'text' ? ' on' : ''}`} disabled={!d.phone} title={d.phone ? 'Send one text to this number' : 'No phone on file'}
                    onClick={() => open(mode === 'text' ? null : 'text')} aria-expanded={mode === 'text'}><IChatL />Send text</button>
                  <span className="mwrap">
                    <button type="button" className="btn more" onClick={() => setMenu(m => !m)} aria-label="More actions" aria-expanded={menu} title="More actions"><IMore /></button>
                    {menu && (
                      <div className="menu" role="menu">
                        <button type="button" role="menuitem" onClick={() => open('merge')}>Merge into…</button>
                        <button type="button" role="menuitem" className="danger-item" style={{ color: '#b91c1c' }} onClick={() => open('delete')}>Delete contact…</button>
                      </div>
                    )}
                  </span>
                </div>
              )}

              <div className="db">
                {mode === 'text' && d && (
                  <div className="cbk-tc">
                    <TextComposer initialTo={d.phone ?? ''} sending={texting} error={textErr} onCancel={() => setMode(null)} onSend={(to, b) => void sendText(to, b)}
                      note="Sent once, not a conversation. Logged in this contact's History."
                      consentLine={d.consent === 'declined'
                        ? <span className="tc-bad">declined texts - it will not be sent</span>
                        : <>text consent <b className={d.consent === 'given' ? 'tc-ok' : ''}>{d.consent === 'given' ? 'given' : 'not recorded'}</b></>} />
                  </div>
                )}
                {mode === 'delete' && d && <DeletePanel d={d} canDelete={hasAccess('contacts', 'del')} onCancel={() => setMode(null)} onMerge={() => open('merge')}
                  onDone={() => { setMode(null); p.onChanged(); p.onClose(); }} />}
                {mode === 'merge' && d && <MergePanel d={d} items={p.listItems} onCancel={() => setMode(null)} onDone={(intoId) => { setMode(null); p.onChanged(); p.onOpenOther(intoId); }} />}

                {/* ── Details (S31) ─────────────────────────────────────────────────────────────── */}
                <section className="box">
                  <div className="bh"><h3>{editing && !isNew ? 'Edit details' : 'Details'}</h3><span className="sp" />
                    {!editing && d?.status === 'active' && <button type="button" className="btn sm" onClick={() => open('edit')}><IEdit />Edit</button>}
                  </div>
                  {editing ? (
                    <div className="grid">
                      {/* v12.10.17 (#1777): dropdowns only - the workflow caller types and the practice's languages. */}
                      <div className="f">
                        <small>Caller type</small>
                        <select data-k="callerType" className={errors.callerType ? 'sel-bad' : ''} value={draft.callerType} onChange={e => setDraft(x => ({ ...x, callerType: e.target.value }))}>
                          <option value="">— not set —</option>
                          {callerTypes.map(t => <option key={t.key} value={t.key}>{t.name}</option>)}
                          {draft.callerType && !ctOf(draft.callerType) && <option value={draft.callerType}>{draft.callerType} (no longer in the workflow)</option>}
                        </select>
                        <div className="ro">From the workflow caller types - no free typing</div>
                        {errors.callerType && <div className="err">{errors.callerType}</div>}
                      </div>
                      <div className="f">
                        <small>Preferred language</small>
                        <select data-k="preferredLanguage" className={errors.preferredLanguage ? 'sel-bad' : ''} value={draft.preferredLanguage} onChange={e => setDraft(x => ({ ...x, preferredLanguage: e.target.value }))}>
                          <option value="">— not set —</option>
                          {languages.map(l => <option key={l} value={l}>{languageName(l)}</option>)}
                          {draft.preferredLanguage && !languages.includes(draft.preferredLanguage) && <option value={draft.preferredLanguage}>{languageName(draft.preferredLanguage)}</option>}
                        </select>
                        <div className="ro">Picks the ID check and Greeting language</div>
                        {errors.preferredLanguage && <div className="err">{errors.preferredLanguage}</div>}
                      </div>
                      {/* v12.10.21 (D8): office caller types - one Full name; Patient - First + Last */}
                      {isOffice
                        ? input({ token: FULLNAME, label: 'Full name', type: 'name', identity: false, section: 'system', place: 'fullName' }, true, "e.g. CVS Pharmacy, Dr. Green's office")
                        : <>{input(sys('first'), false, undefined, prefLine(PREF_FIRST))}{input(sys('last'), false, undefined, prefLine(PREF_LAST))}</>}
                      {/* v12.10.17 (#1746 I7): Phone 1-4 - number, Type, one Primary and (v12.10.21 D7) one Callback. */}
                      {draft.phones.map((ph, i) => {
                        const k = `phone${i + 1}`;
                        return (
                          <div className="f full cph" key={k}>
                            <small>Phone {i + 1}</small>
                            <div className="cph-row">
                              <input data-k={k} className={errors[k] ? 'bad' : ''} value={maskPhone(ph.phone)} type="tel" inputMode="tel" placeholder="+1 (___) ___-____" autoComplete="off"
                                onChange={e => setPhone(i, { phone: phoneFromInput(e.target.value, ph.phone) })} aria-invalid={!!errors[k]} aria-label={`Phone ${i + 1}`} />
                              <select value={ph.type} onChange={e => setPhone(i, { type: e.target.value })} aria-label={`Phone ${i + 1} type`}>
                                <option value="">Type</option>
                                {PHONE_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                              </select>
                              <label className="cph-pri"><input type="radio" name="primaryPhone" checked={ph.primary} onChange={() => setPhone(i, { primary: true })} />Primary</label>
                              <label className="cph-pri"><input type="checkbox" checked={ph.callback} onChange={e => setPhone(i, { callback: e.target.checked })} />Callback</label>
                            </div>
                            {errors[k] && <div className="err">{errors[k]}</div>}
                          </div>
                        );
                      })}
                      {/* v12.10.21 (#1941 D11): Caller + Relation rows - information only, never used to match */}
                      {(draft.callers.length ? draft.callers : []).map((x, i) => (
                        <div className="f full cph" key={'cl' + i}>
                          <small>Caller {draft.callers.length > 1 ? i + 1 : ''}</small>
                          <div className="cph-row">
                            <input value={x.name} placeholder={`Who calls for this ${isOffice ? 'office' : 'patient'}`} autoComplete="off" onChange={e => setCaller(i, { name: e.target.value })} aria-label="Caller name" />
                            <select value={x.relation} onChange={e => setCaller(i, { relation: e.target.value })} aria-label="Relation">
                              <option value="">Relation</option>
                              {relations.map(r => <option key={r} value={r}>{r}</option>)}
                            </select>
                            <button type="button" className="btn sm" onClick={() => setDraft(y => ({ ...y, callers: y.callers.filter((_, j) => j !== i) }))} aria-label="Remove this caller">Remove</button>
                          </div>
                          <div className="ro">{x.phone ? `Calls from ${maskPhone(x.phone)} · ` : ''}information only - never used to match</div>
                        </div>
                      ))}
                      {draft.callers.length < (opts.data?.maxCallers ?? 5) && (
                        <div className="f full"><button type="button" className="btn sm" onClick={() => setDraft(y => ({ ...y, callers: [...y.callers, { name: '', relation: '', phone: '' }] }))}><IPlus />Add caller</button></div>
                      )}
                      <div className="f">
                        <small>Email</small>
                        <input data-k="email" className={errors.email ? 'bad' : ''} value={draft.email} type="email" inputMode="email" placeholder="name@example.com" autoComplete="off"
                          onChange={e => setDraft(x => ({ ...x, email: e.target.value }))} aria-invalid={!!errors.email} />
                        {errors.email && <div className="err">{errors.email}</div>}
                      </div>
                      {/* v12.10.8 (#1221 S48): Date of birth | ZIP code, Address, System ID | External ID. (#1227): an Off field is not drawn. */}
                      {has('dob') && !isOffice && input(sys('dob'))}
                      {has('zip') && input(sys('zip'))}
                      {has('address') && <AddressEdit addr={draft.addr} setAddr={setAddr} onPick={(a) => setDraft(x => ({ ...x, addr: a }))} errors={errors} label={sys('address').label} />}
                      <div className="f"><small>System ID</small><div className={isNew ? 'na' : ''}>{isNew ? 'Given when saved' : d?.systemId}</div><div className="ro">Set by VoiceSpectrum - can't be changed.</div></div>
                      {input(sys('externalId'), false, 'ID from your practice system')}
                    </div>
                  ) : (
                    <div className="grid">
                      {/* v12.10.21 (D8 D12): office - one Full name; Patient - First | Last, each with the tick when a call confirmed it */}
                      {isOffice
                        ? <div className="f full"><small>Full name</small><div className={d?.fullName ? '' : 'na'}>{d?.fullName || 'Not on file'}{d?.fullName && d.fullNameConfirmed && <> <VTick why={confirmTip(d.fullNameConfirmed)} /></>}</div></div>
                        : <>{view(sys('first').label, sys('first').value, false, 'first', sys('first'))}{view(sys('last').label, sys('last').value, false, 'last', sys('last'))}</>}
                      {/* v12.10.17 (#1777): Caller type (colour dot + name from the workflow) and Preferred language - v12.10.21 (C3 C4) both follow the latest call */}
                      <div className="f"><small>Caller type</small>{d?.callerType
                        ? <div><span className="ctdot"><i style={{ background: ct?.color || UNCLASSIFIED }} />{ct?.name ?? d.callerType}</span></div>
                        : <div className="na">Not set</div>}<div className="ro">The latest call sets it</div></div>
                      <div className="f"><small>Preferred language</small><div className={d?.preferredLanguage ? '' : 'na'}>{languageName(d?.preferredLanguage) || 'Not set'}</div><div className="ro">The language the latest call ended in</div></div>
                      {/* v12.10.21 (D6 D7 D12 D18): Phone 1-4 always shown; ★ Primary, the Callback pill, the tick (how many times verified); a click copies the digits */}
                      {Array.from({ length: MAX_PHONES }, (_, i) => i + 1).map(slot => {
                        const r = phoneRows.find(x => x.slot === slot);
                        if (!r) return <div className="f" key={'p' + slot}><small>Phone {slot}</small><div className="na">Not on file</div></div>;
                        return (
                          <div className="f" key={'p' + slot}><small>Phone {slot}</small>
                            <div><button type="button" className="phc" onClick={() => copyDigits(r.phone)} title="Copy the number (digits only)">{maskPhone(r.phone)}</button>
                              {phoneTypeLabel(r.type) && <span className="dim"> · {phoneTypeLabel(r.type)}</span>}
                              {r.primary && phoneRows.length > 1 && <span className="star"> ★ Primary</span>}
                              {r.callback && <span className="cbt"><ICb />Callback</span>}
                              {r.verifiedCount > 0 && <> <VTick why={`Verified ${r.verifiedCount} time${r.verifiedCount === 1 ? '' : 's'}${r.lastVerifiedCallRef ? ` - last call ${formatReference(r.lastVerifiedCallRef)}` : ''}${r.lastVerifiedAt ? ` · ${new Date(r.lastVerifiedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}` : ''}`} /></>}
                            </div>
                          </div>
                        );
                      })}
                      {/* v12.10.21 (#1941 D11): Caller + Relation rows, newest first - information only, never used to match */}
                      {(d?.callers ?? []).length === 0
                        ? <><div className="f"><small>Caller</small><div className="na">Nobody has called for this {isOffice ? 'office' : 'patient'}</div></div><div className="f"><small>Relation</small><div className="na">—</div></div></>
                        : (d?.callers ?? []).map((x, i) => (
                          <div className="f full" key={'c' + i}><small>Caller{(d?.callers?.length ?? 0) > 1 ? ` ${i + 1}` : ''}</small>
                            <div>{x.name || <span className="na">No name</span>}{x.relation ? <span className="dim"> · {x.relation}</span> : null}
                              {x.confirmed && <> <VTick why={`Confirmed by the caller${x.callRef ? `, call ${formatReference(x.callRef)}` : ''}`} /></>}</div>
                            <div className="ro">{x.phone ? `Calls from ${maskPhone(x.phone)} · ` : ''}{x.callRef ? `last call ${formatReference(x.callRef)} · ` : ''}information only</div>
                          </div>
                        ))}
                      {view('Email', d?.email)}
                      {has('dob') && !isOffice && view(sys('dob').label, fmtDob(sys('dob').value), false, 'dob', sys('dob'))}
                      {has('zip') && view(sys('zip').label, sys('zip').value, false, 'zip', sys('zip'))}
                      {has('address') && view(sys('address').label, sys('address').value || addressLine(d?.address), true)}
                      {view('System ID', d?.systemId)}
                      {view('External ID', d?.externalId)}
                      {d?.source && view('Source', sourceLine(d.source) || sourceShort(d.source.display, d.source.importSource), true)}{/* v12.10.17 (#1746 I2); v12.10.21 (D5) */}
                    </div>
                  )}
                  {isNew && (
                    <div style={{ marginTop: 14 }}>
                      <div className="f"><small>Text consent</small></div>
                      <div className="radios">
                        {(['', 'given', 'declined'] as const).map(v => (
                          <label key={v || 'none'}><input type="radio" name="newconsent" checked={draft.consent === v} onChange={() => setDraft(x => ({ ...x, consent: v }))} />{v === '' ? 'Not recorded' : v === 'given' ? 'Consent given' : 'Declined'}</label>
                        ))}
                      </div>
                    </div>
                  )}
                </section>

                {/* ── Custom (S32): every other caller / subject Vocabulary field ─────────────────── */}
                <section className="box">
                  <div className="bh"><h3>Custom</h3><span className="sp" /><span className="dim bhnote">fields the practice added in Vocabulary</span></div>
                  {customRows.length === 0 && <p className="dim" style={{ margin: 0, fontSize: 13 }}>No custom fields. They are added in Settings › Vocabulary › Fields.</p>}
                  {customRows.length > 0 && (
                    <div className="grid">
                      {customRows.map(f => editing ? input(f) : view(f.label, showValue(f), false, f.token, f))}
                    </div>
                  )}
                </section>

                {!isNew && d && (
                  <>
                    <ConsentBox d={d} by={consentBy} open={mode === 'consent'} setOpen={(b) => (b ? open('consent') : setMode(null))}
                      onSaved={(nd) => { qc.setQueryData(['contact', p.id], nd); p.onChanged(); }} />
                    <LinksBox d={d} open={mode === 'link'} setOpen={(b) => (b ? open('link') : setMode(null))} onOpenOther={p.onOpenOther}
                      onSaved={(nd) => { qc.setQueryData(['contact', p.id], nd); p.onChanged(); }} />
                    <section className="box">
                      <div className="bh"><h3>Calls</h3><span className="sp" /><span className="dim" style={{ fontSize: 12.5 }}>{callsLabel(d.callCount)}</span></div>
                      {d.calls.length === 0 && <p className="dim" style={{ margin: 0 }}>No calls yet.</p>}
                      {d.calls.map(c => (
                        <div className="crow" key={c.id}>
                          {c.reference
                            ? <button type="button" className="ref" onClick={() => navigate(`/messages?q=${encodeURIComponent(c.reference!)}`)} title="Open this call in Messages">{formatReference(c.reference)}{/* v12.10.17 (#1773): shown as Messages shows it; the search still gets the stored form */}</button>
                            : <span className="ref">call</span>}
                          <span className="t">{fmtWhen(c.startedAt)}{c.durationSeconds ? ` · ${Math.floor(c.durationSeconds / 60)}:${String(c.durationSeconds % 60).padStart(2, '0')}` : ''}</span>
                          <span className="dim" style={{ fontSize: 12.5 }}>{ruleText(c.rule)}{c.linkCheck && <span className="lab chk" title="The caller said the name was not right at Confirm">CHECK</span>}</span>
                        </div>
                      ))}
                    </section>
                    <section className="box">
                      <div className="bh"><h3>History</h3></div>
                      <ul className="hist">
                        {d.history.map(h => <li key={h.id}><span className="when">{fmtFull(h.at)}</span><span>{histText(h, (k) => ctOf(k)?.name ?? k)}<br /><span className="who">{h.actorType === 'call' ? (h.callRef ? `Call #${h.callRef}` : 'A call') : h.actorType === 'staff' ? (h.actor || 'Staff') : h.actorType === 'import' ? (h.actor || 'Import') : 'VoiceSpectrum'}</span></span></li>)}
                      </ul>
                    </section>
                  </>
                )}
              </div>
            </>
          )}
        </div>

        {editing && (
          <div className="dfoot">
            <span className="lbl2">{isNew ? 'Adding a contact' : `Editing ${d?.name || d?.systemId || ''}`}</span>
            <button type="button" className="btn" onClick={cancelEdit} disabled={saving}>Cancel <span className="kbd">Esc</span></button>
            <button type="button" className="btn pri" onClick={() => void save()} disabled={saving}>{saving ? 'Saving…' : isNew ? 'Add contact' : 'Save changes'} <span className="kbd">Ctrl+Enter</span></button>
          </div>
        )}
      </aside>
    </>
  );
}

// ── #1179 Address: one line with suggestions that fill the parts; the parts stay editable ────────────────────────
type Suggestion = { description: string; placeId: string };
type AddrDetail = { formattedAddress: string; street1?: string | null; street2?: string | null; city?: string | null; state?: string | null; zip?: string | null };
function newSession(): string { return Math.random().toString(36).slice(2) + Date.now().toString(36); }

function AddressEdit({ addr, setAddr, onPick, errors, label }: {
  addr: AddrParts; setAddr: (k: keyof AddrParts, v: string) => void; onPick: (a: AddrParts) => void; errors: Record<string, string>; label: string;
}) {
  const [q, setQ] = useState('');
  const [sugg, setSugg] = useState<Suggestion[]>([]);
  const [off, setOff] = useState(false);       // no Maps provider - the parts are typed by hand
  const session = useRef(newSession());
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  function type(v: string) {
    setQ(v);
    if (timer.current) clearTimeout(timer.current);
    if (off || v.trim().length < 3) { setSugg([]); return; }
    timer.current = setTimeout(() => {
      api.get<Suggestion[]>(`/t2/address/autocomplete?q=${encodeURIComponent(v.trim())}&session=${session.current}`)
        .then(r => setSugg(r.slice(0, 5)))
        .catch(e => { setSugg([]); if (e instanceof ApiError && e.status === 400) setOff(true); });
    }, 250);
  }
  async function pick(s: Suggestion) {
    setSugg([]); setQ('');
    try {
      const dd = await api.get<AddrDetail>(`/t2/address/details?placeId=${encodeURIComponent(s.placeId)}&session=${session.current}`);
      onPick({ address1: dd.street1 ?? s.description.split(',')[0] ?? '', address2: dd.street2 ?? '', city: dd.city ?? '', state: dd.state ?? '', zip: dd.zip ?? '' });
      toast('success', 'Address filled.', 'Street, city, state and ZIP came from the suggestion - check them before saving.');
    } catch { toast('error', 'Address not filled', 'The suggestion could not be read - type the parts below.'); }
    session.current = newSession();
  }
  const part = (k: keyof AddrParts, l: string, cls = '', ph = '', mode?: React.HTMLAttributes<HTMLInputElement>['inputMode']) => {
    const ek = addrTok(k);
    return (
      <div className={`f${cls ? ' ' + cls : ''}`}>
        <small>{l}</small>
        <input data-k={ek} className={errors[ek] ? 'bad' : ''} value={addr[k]} placeholder={ph} inputMode={mode} autoComplete="off"
          maxLength={k === 'state' ? 2 : k === 'zip' ? 10 : 120}
          onChange={e => setAddr(k, k === 'state' ? e.target.value.toUpperCase() : e.target.value)} aria-invalid={!!errors[ek]} />
        {errors[ek] && <div className="err">{errors[ek]}</div>}
      </div>
    );
  };
  return (
    <>
      {!off && (
        <div className="f full asearch">
          <small>{label}</small>
          <input value={q} onChange={e => type(e.target.value)} placeholder="Start typing an address" autoComplete="off" aria-label="Search an address" />
          {sugg.length > 0 && (
            <div className="sugg" role="listbox">
              {sugg.map(s => (
                <button type="button" role="option" aria-selected={false} key={s.placeId} onMouseDown={(e) => { e.preventDefault(); void pick(s); }} onClick={() => void pick(s)}>
                  <IPin /><span>{s.description}</span>
                </button>
              ))}
              <div className="pw">Suggestions by Google</div>
            </div>
          )}
        </div>
      )}
      {part('address1', 'Street line 1', 'full')}
      {part('address2', 'Street line 2', 'full', 'Apt, suite (optional)')}
      {part('city', 'City')}
      <div className="grid sz">
        {part('state', 'State', '', 'NJ')}
        {part('zip', 'Address ZIP', '', '', 'numeric')}
      </div>
    </>
  );
}

/** v12.10.21 (#1939 #1956): what the call did to this contact, in words. */
function ruleText(rule: string): string {
  if (rule.startsWith('new')) return rule === 'new_twin' ? 'created this contact - a confirmed different name on the same phone + DOB' : 'created this contact';
  switch (rule) {
    case 'id_check': return 'confirmed at the ID check';
    case 'phone_dob': return 'matched - calling phone + date of birth';
    case 'phone_dob_name': return 'matched - phone + date of birth, the name picked it';
    case 'dob_name_phone_added': case 'dob_phone_added': return 'matched - date of birth + name, this phone added';
    case 'office_known': return 'matched - known office number';
    case 'office_name_zip': return 'matched - office name + ZIP, this number added';
    case 'office_new': return 'created this office contact';
    case 'name_phone_dob_zip': case 'name_phone_dob': return 'matched - same phone';
    default: return 'matched - another phone';
  }
}

function histText(h: HistRow, callerTypeName: (key: string) => string = (k) => k): ReactNode {
  // v12.10.17 (#1777): a caller type is stored as its workflow key - History shows its name; a language as its code.
  if (h.kind === 'field' && h.field === 'Caller type') h = { ...h, oldValue: h.oldValue ? callerTypeName(h.oldValue) : h.oldValue, newValue: h.newValue ? callerTypeName(h.newValue) : h.newValue };
  if (h.kind === 'field' && h.field === 'Preferred language') h = { ...h, oldValue: h.oldValue ? languageName(h.oldValue) : h.oldValue, newValue: h.newValue ? languageName(h.newValue) : h.newValue };
  switch (h.kind) {
    // v12.10.8 (#1223): 'Added on call' / 'Added by <user>'; rows written before 12.10.8 said 'Added by hand'.
    case 'created': return h.actorType === 'call' ? <>Added on call #{h.callRef}</> : h.actorType === 'import' ? <>{h.note || 'Added by import'}</> : <>{h.note && h.note !== 'Added by hand' ? h.note : `Added by ${h.actor || 'staff'}`}</>;
    case 'import': return <>{h.note}</>;   // v12.10.17 (#1746 I10): "Phone 2 added (Home) · … · matched on phone + date of birth
    case 'matched': return <>Call #{h.callRef} matched this contact{h.note ? ` (${h.note})` : ''}</>;
    case 'field': return <>{h.field}: {h.oldValue ? <><s>{h.oldValue}</s> → </> : 'added '}{h.newValue ?? <em>cleared</em>}{h.note ? ` (${h.note})` : ''}</>;
    case 'consent': return <>Text consent {h.newValue === 'given' ? 'given' : 'declined'}{h.oldValue && h.oldValue !== h.newValue ? ` (was ${h.oldValue})` : ''}{h.note ? (h.actorType === 'staff' ? ` - “${h.note}”` : ` - ${h.note}`) : ''}</>;
    case 'text_not_sent': return <>{h.note || 'Text not sent'}</>;
    case 'text_sent': case 'text_failed': return <>{h.note}{h.newValue ? <>: “{h.newValue}”</> : null}</>;
    case 'merged': case 'merged_away': case 'link': case 'unlink': case 'deleted': return <>{h.note}</>;
    // v12.10.21 (#1840 R2): a different detail from a caller - the contact is unchanged; (#1919 C3) the link CHECK
    case 'other_detail': return <>{h.field}: the caller gave another detail - {h.newValue}{h.oldValue ? <> (the contact keeps {h.oldValue})</> : null}</>;
    case 'link_check': return <>{h.note}</>;
    default: return <>{h.kind}{h.note ? ` - ${h.note}` : ''}</>;
  }
}

// ── #1181 Text consent, in the prototype's words ──────────────────────────────────────────────────────────────
function ConsentBox({ d, by, open, setOpen, onSaved }: { d: Detail; by: string | null; open: boolean; setOpen: (b: boolean) => void; onSaved: (d: Detail) => void }) {
  const [state, setState] = useState<'given' | 'declined'>(d.consent === 'declined' ? 'declined' : 'given');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const last = d.history.find(h => h.consentKey === 'sms' && h.kind === 'consent');
  async function save() {
    if (note.trim().length > 120) { toast('error', 'Note too long', 'One line - 120 characters at most.'); return; }
    setBusy(true);
    try {
      const nd = await api.post<Detail>(`/t2/contacts/${d.id}/consent`, { state, note: note.trim() || null });
      toast('success', 'Consent recorded.', state === 'given' ? 'Texts may be sent.' : 'No texts are sent.');
      setOpen(false); setNote(''); onSaved(nd);
    } catch (e) { toast('error', 'Consent not recorded', errText(e, 'Nothing was saved.')); }
    finally { setBusy(false); }
  }
  const cls = d.consent === 'given' ? 'given' : d.consent === 'declined' ? 'declined' : 'none';
  if (open) return (
    <section className="box cbox-edit">
      <div className="bh"><h3>Record text consent</h3></div>
      <div className="radios">
        <label><input type="radio" name="cs" checked={state === 'given'} onChange={() => setState('given')} />Consent given</label>
        <label><input type="radio" name="cs" checked={state === 'declined'} onChange={() => setState('declined')} />Declined</label>
      </div>
      <div className="f" style={{ marginTop: 10 }}><small>Note (optional)</small><input value={note} maxLength={120} onChange={e => setNote(e.target.value)} placeholder="Texts only after 5 PM" /></div>
      <p className="cline" style={{ margin: '8px 0 0' }}>Logged with today's date and your name.</p>
      <div className="bfoot">
        <button type="button" className="btn sm" onClick={() => setOpen(false)} disabled={busy}>Cancel</button>
        <button type="button" className="btn sm pri" onClick={() => void save()} disabled={busy}>{busy ? 'Saving…' : 'Save consent'}</button>
      </div>
    </section>
  );
  return (
    <section className="box">
      <div className="bh"><h3>Text consent</h3><span className="sp" />
        {d.status === 'active' && <button type="button" className="btn sm" onClick={() => setOpen(true)}><IEdit />Record consent</button>}
      </div>
      {cls === 'none'
        ? <div className="cline">Not recorded. The AI asks on the next call if a text is offered.</div>
        : <>
            <div className={`cstate ${cls}`}>{cls === 'given' ? 'Consent given' : 'Declined texts'}</div>
            {last && <div className="cline">{fmtFull(last.at)}{by ? ` · ${by}` : ''}</div>}
            {last?.note && last.actorType === 'staff' && <div className="cline">“{last.note}”</div>}
          </>}
    </section>
  );
}

// ── #1178 Linked people ───────────────────────────────────────────────────────────────────────────────────────
function LinksBox({ d, open, setOpen, onSaved, onOpenOther }: { d: Detail; open: boolean; setOpen: (b: boolean) => void; onSaved: (d: Detail) => void; onOpenOther: (id: number) => void }) {
  const [rel, setRel] = useState('Parent');
  const [q, setQ] = useState('');
  const [pick, setPick] = useState<ListItem | null>(null);
  const [busy, setBusy] = useState(false);
  const [rowMenu, setRowMenu] = useState<number | null>(null);
  const first = d.first || d.name.split(' ')[0] || d.systemId;
  const remote = useQuery({
    queryKey: ['contacts-link', q.trim()],
    queryFn: () => api.get<ListResponse>(`/t2/contacts?q=${encodeURIComponent(q.trim())}`),
    enabled: open && q.trim().length > 1,
  });
  const linked = new Set((d.links ?? []).map(l => l.id));
  const pool = (remote.data?.items ?? []).filter(i => i.id !== d.id && !linked.has(i.id)).slice(0, 6);
  function reset() { setQ(''); setPick(null); setRel('Parent'); }
  async function link() {
    if (!pick) return;
    setBusy(true);
    try {
      const nd = await api.post<Detail>(`/t2/contacts/${d.id}/links`, { otherId: pick.id, relation: rel });
      toast('success', 'Linked.', "Both contacts get their side - written to both contacts' History.");
      reset(); setOpen(false); onSaved(nd);
    } catch (e) { toast('error', 'Not linked', errText(e, 'Nothing was changed.')); }
    finally { setBusy(false); }
  }
  async function unlink(l: LinkRow) {
    setRowMenu(null); setBusy(true);
    try {
      const nd = await api.delete<Detail>(`/t2/contacts/${d.id}/links/${l.id}`);
      toast('success', 'Unlinked.', "Written to both contacts' History.");
      onSaved(nd);
    } catch (e) { toast('error', 'Not unlinked', errText(e, 'Nothing was changed.')); }
    finally { setBusy(false); }
  }
  return (
    <section className="box">
      <div className="bh"><h3>Linked people</h3><span className="sp" />
        {!open && d.status === 'active' && <button type="button" className="btn sm" onClick={() => { reset(); setOpen(true); }}><IPlus />Link person</button>}
      </div>
      {(d.links ?? []).length === 0 && !open && <p className="dim" style={{ margin: 0, fontSize: 13 }}>No linked people.</p>}
      {(d.links ?? []).map(l => (
        <div className="lp" key={l.id}>
          <div className="av sm">{initials(l.name) || <IPhone size={14} />}</div>
          <div className="t"><b>{l.name || l.systemId}</b><small>{first} is {l.relation.toLowerCase()} of {l.first || l.name.split(' ')[0] || l.systemId}</small></div>
          <button type="button" className="btn sm" onClick={() => onOpenOther(l.id)}>Open</button>
          <span className="mwrap">
            <button type="button" className="btn sm" aria-label={`More for ${l.name || l.systemId}`} aria-expanded={rowMenu === l.id} onClick={() => setRowMenu(m => (m === l.id ? null : l.id))} disabled={busy}><IMore /></button>
            {rowMenu === l.id && <div className="menu" role="menu"><button type="button" role="menuitem" onClick={() => void unlink(l)}>Unlink</button></div>}
          </span>
        </div>
      ))}
      {open && (
        <div className="mrg lform">
          <div className="lrel">
            <b>{first}</b> is
            <select value={rel} onChange={e => setRel(e.target.value)} aria-label="Relation">{RELATIONS.map(r => <option key={r}>{r}</option>)}</select>
            of {pick ? <b>{pick.name || pick.systemId}</b> : '…'}
          </div>
          {!pick && (
            <>
              <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Search a contact by name, phone or DOB" aria-label="Find the person to link" />
              {q.trim().length > 1 && (
                <div className="lres">
                  {pool.length === 0 && <div className="dim" style={{ padding: '8px 10px', fontSize: 13 }}>{remote.isFetching ? 'Searching…' : 'No other contacts match.'}</div>}
                  {pool.map(i => (
                    <button type="button" key={i.id} onClick={() => setPick(i)}>
                      <span>{i.name || 'No name yet'}</span><small>{i.systemId}{i.dob ? ` · DOB ${fmtDob(i.dob)}` : ''}{i.phone ? ` · ${maskPhone(i.phone)}` : ''}</small>
                    </button>
                  ))}
                </div>
              )}
            </>
          )}
          <div className="bfoot">
            {pick && <button type="button" className="btn sm" onClick={() => setPick(null)} disabled={busy}>Change</button>}
            <button type="button" className="btn sm" onClick={() => { reset(); setOpen(false); }} disabled={busy}>Cancel</button>
            <button type="button" className="btn sm pri" onClick={() => void link()} disabled={!pick || busy}>{busy ? 'Linking…' : 'Link'}</button>
          </div>
        </div>
      )}
    </section>
  );
}

// v12.10.11.1 (#1489): delete a contact. It goes into the 30-day restorable set (VoiceSpectrum Support can restore it).
// Without Contacts › Delete the panel says so. A contact linked to calls still in Messages is refused by the server (409,
// reason "calls") - the panel then offers "Delete with its calls" or "Merge into…".
function DeletePanel({ d, canDelete, onCancel, onMerge, onDone }: { d: Detail; canDelete: boolean; onCancel: () => void; onMerge: () => void; onDone: () => void }) {
  const [busy, setBusy] = useState(false);
  const [calls, setCalls] = useState(0);   // set from the server's 409 - removed (test) calls do not count
  const who = `${d.name || d.systemId} (${d.systemId})`;
  const plural = (n: number) => `${n} call${n === 1 ? '' : 's'}`;
  async function del(withCalls: boolean) {
    setBusy(true);
    try {
      await api.delete(`/t2/contacts/${d.id}${withCalls ? '?withCalls=true' : ''}`);
      toast('success', 'Contact deleted.', `${who}${withCalls && calls ? ` and its ${plural(calls)}` : ''} - VoiceSpectrum Support can restore it for 30 days.`);
      onDone();
    } catch (e) {
      const b = e instanceof ApiError && e.status === 409 ? (e.body as { reason?: string; calls?: number } | null) : null;
      if (b?.reason === 'calls' && b.calls) setCalls(b.calls);
      else toast('error', 'Not deleted', errText(e, 'Nothing was changed.'));
    } finally { setBusy(false); }
  }
  return (
    <div className="mrg">
      <b>Delete {who}?</b>
      {!canDelete ? (
        <>
          <div className="warn">You can't delete contacts - it needs <b>Contacts › Delete</b>. Ask your practice admin.</div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}><button type="button" className="btn sm" onClick={onCancel}>Close</button></div>
        </>
      ) : calls > 0 ? (
        <>
          <div className="warn">
            This contact is linked to <b>{plural(calls)}</b> in Messages, so it can't be deleted on its own.
            <b> Delete with its calls</b> removes {calls === 1 ? 'that call' : 'those calls'} from Messages too - or <b>merge</b> it into the contact it really is.
            VoiceSpectrum Support can restore a delete for 30 days.
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <button type="button" className="btn sm" onClick={onCancel} disabled={busy}>Cancel</button>
            <button type="button" className="btn sm" onClick={onMerge} disabled={busy}>Merge into…</button>
            <button type="button" className="btn sm danger" onClick={() => void del(true)} disabled={busy}>{busy ? 'Deleting…' : 'Delete with its calls'}</button>
          </div>
        </>
      ) : (
        <>
          <div className="warn">It leaves Contacts now. VoiceSpectrum Support can restore it for 30 days; after that it is removed for good.</div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button type="button" className="btn sm" onClick={onCancel} disabled={busy}>Cancel</button>
            <button type="button" className="btn sm danger" onClick={() => void del(false)} disabled={busy}>{busy ? 'Deleting…' : 'Delete'}</button>
          </div>
        </>
      )}
    </div>
  );
}

function MergePanel({ d, items, onCancel, onDone }: { d: Detail; items: ListItem[]; onCancel: () => void; onDone: (intoId: number) => void }) {
  const [q, setQ] = useState('');
  const [pick, setPick] = useState<ListItem | null>(null);
  const [busy, setBusy] = useState(false);
  const remote = useQuery({
    queryKey: ['contacts-merge', q.trim()],
    queryFn: () => api.get<ListResponse>(`/t2/contacts?q=${encodeURIComponent(q.trim())}`),
    enabled: q.trim().length > 1,
  });
  const pool = useMemo(() => (q.trim().length > 1 ? remote.data?.items ?? [] : items).filter(i => i.id !== d.id).slice(0, 30), [q, remote.data, items, d.id]);
  async function merge() {
    if (!pick) return;
    setBusy(true);
    try {
      await api.post<Detail>(`/t2/contacts/${d.id}/merge`, { intoId: pick.id });
      toast('success', 'Contacts merged.', `${d.systemId} is now part of ${pick.systemId}.`);
      onDone(pick.id);
    } catch (e) { toast('error', 'Merge not done', errText(e, 'Nothing was changed.')); }
    finally { setBusy(false); }
  }
  return (
    <div className="mrg">
      <b>Merge {d.name || d.systemId} ({d.systemId}) into…</b>
      {!pick && (
        <>
          <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Search the contact that stays - name, phone, DOB, ID" aria-label="Find the contact that stays" />
          <div className="lres">
            {pool.length === 0 && <div className="dim" style={{ padding: '8px 10px', fontSize: 13 }}>No other contacts match.</div>}
            {pool.map(i => (
              <button type="button" key={i.id} onClick={() => setPick(i)}>
                <span>{i.name || 'No name yet'}</span><small>{i.systemId}{i.dob ? ` · DOB ${fmtDob(i.dob)}` : ''}{i.phone ? ` · ${maskPhone(i.phone)}` : ''}</small>
              </button>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}><button type="button" className="btn sm" onClick={onCancel}>Cancel</button></div>
        </>
      )}
      {pick && (
        <>
          <div className="warn">
            <b>{pick.name || 'No name yet'} ({pick.systemId}) stays.</b> {d.name || 'No name yet'} ({d.systemId}) is merged into it: every call, the consent history,
            the linked people and the History move over; {pick.systemId} keeps its own details and only its empty ones are filled from {d.systemId}.
            <br /><b>A merge can't be undone yet.</b>
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button type="button" className="btn sm" onClick={() => setPick(null)} disabled={busy}>Back</button>
            <button type="button" className="btn sm danger" onClick={() => void merge()} disabled={busy}>{busy ? 'Merging…' : `Merge into ${pick.systemId}`}</button>
          </div>
        </>
      )}
    </div>
  );
}
